<template>
  <div class="p-4 sm:p-10">
    <div class="max-w-7xl mx-auto">
      <div class="flex flex-col lg:flex-row -mx-4">
        <div v-if="data && data.project && data.project.client" class="w-full lg:w-64 px-4">
          <div class="rounded bg-white shadow">
            <div class="p-6 flex flex-col items-center space-y-4">
              <img
                v-if="data.project.client.logo"
                :src="data.project.client.logo"
                :alt="data.project.client.name"
                class="rounded-full border w-24 h-24"
              />
              <h3 class="text-lg font-medium">
                {{ data.project.client.name }}
              </h3>
            </div>
          </div>
        </div>
        <div class="w-full mt-8 lg:mt-0 sm:flex-1 px-4">
          <div v-if="data && data.project" class="rounded bg-white shadow mb-8">
            <div class="p-6 flex flex-col items-center space-y-4">
              <span class="uppercase text-sm tracking-wide text-gray-600">Project</span>
              <h5 class="text-base font-medium">
                {{ data.project.name }}
              </h5>
            </div>
          </div>
          <div>
            <ApprovalRequestList
              v-if="data && data.approvalRequests"
              :approval-requests="data.approvalRequests"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/client';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import components from './projectApprovalRequests/components';

const client = new ApiClient('/');

export default {
  components,
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pathname: '',
      query: {
        expires: '',
        signature: '',
      },
      data: null,
    };
  },
  provide() {
    return {
      submitReview: this.submitReview,
    };
  },
  created() {
    this.getUrlParts();
    this.fetchApprovalRequests();
  },
  methods: {
    getUrlParts() {
      try {
        const url = new URL(decodeURIComponent(this.$route.query.url));
        const params = url.searchParams;
        const [email, ...restURLParts] = url.pathname.split('/').reverse();
        this.pathname = [encodeURIComponent(email), ...restURLParts].reverse().join('/');
        this.query.expires = params.get('expires');
        this.query.signature = params.get('signature');
      } catch (error) {
        //
      }
    },
    async fetchApprovalRequests() {
      if (typeof this.pathname !== 'string' || this.pathname.length === 0) {
        return;
      }

      try {
        const response = await client.get(this.pathname, { params: this.query });

        this.data = mapKeysToCamelCase(response.data.data, true);
      } catch (error) {
        //
      }
    },
    async submitReview(formData) {
      try {
        await client.post(this.pathname, formData, { params: this.query });

        await this.fetchApprovalRequests();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
